<template>
  <div class="kosyoku">
    <h3>個食手当</h3>
    <div class="multi-date-table" v-for="(item, index) in form.kosyoku" :key="index">
      <div class="head"><b>個食{{ (index + 1) }}</b></div>
      <div class="item flex">
          <b class="width-55">取得日</b>
          <p>{{ item.shinsei_date }}</p>
      </div>
    </div>
    <div class="col-item">
      <b class="title">備考</b>
      <p class="pre">{{ form.notes ?? '無し' }}</p>
    </div>
  </div>
</template>

<script lang="ts">

import { defineComponent } from "vue";
import { dateFormat } from "@/filters/common";
import { Shinsei } from "@/types/Shinsei";

export default defineComponent({
  props: {
    form: {
      type: Object as () => Shinsei,
      default: null
    },
  },
  setup() {

    return {
      dateFormat,
    };
  },
  components: {

  }
})
</script>
<style lang="scss" scoped>
@import '@scss/components/shinsei-detail.scss';
</style>
